var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndocrinology(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.1,9.645h-2.78h-2.78v17.184 c0,1.303-1.4,2.174-0.765,3.063c0.698,0.979,1.747-0.316,3.545-0.316s2.847,1.295,3.546,0.316c0.636-0.889-0.766-1.76-0.766-3.063 V9.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B5889",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M19.84,2.827 c-1.214,0.737-1.486-0.139-2.123,0.419c-0.637,0.559-0.866,0.978-1.397,0.978c-0.53,0-0.76-0.419-1.396-0.978 c-0.637-0.559-0.91,0.317-2.124-0.419c-1.704-1.033-1.818,1.509-1.399,2.906c0.449,1.499,2.14,2.18,2.14,3.409v1.258 c0-1.222,1.88,0,2.78,0s2.78-1.222,2.78,0V9.142c0-1.229,1.69-1.91,2.141-3.409C21.659,4.336,21.544,1.793,19.84,2.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.499,27.156c0,0.232-0.977,0.838-2.18,0.838s-2.179-0.605-2.179-0.838c0-0.23,0.976,0,2.179,0 S18.499,26.926,18.499,27.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.499,25.623c0,0.232-0.977,0.838-2.18,0.838s-2.179-0.605-2.179-0.838c0-0.23,0.976,0,2.179,0 S18.499,25.393,18.499,25.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.499,24.09c0,0.23-0.977,0.838-2.18,0.838s-2.179-0.607-2.179-0.838c0-0.232,0.976,0,2.179,0 S18.499,23.857,18.499,24.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.499,22.557c0,0.23-0.977,0.838-2.18,0.838s-2.179-0.607-2.179-0.838c0-0.232,0.976,0,2.179,0 S18.499,22.324,18.499,22.557z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.499,21.023c0,0.23-0.977,0.838-2.18,0.838s-2.179-0.607-2.179-0.838c0-0.232,0.976,0,2.179,0 S18.499,20.791,18.499,21.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.499,12.857c0,0.231-0.977,0.838-2.18,0.838s-2.179-0.606-2.179-0.838c0-0.232,0.976,0,2.179,0 S18.499,12.625,18.499,12.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M18.499,11.236c0,0.231-0.977,0.838-2.18,0.838s-2.179-0.607-2.179-0.838c0-0.232,0.976,0,2.179,0 S18.499,11.004,18.499,11.236z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.961,7.339 c-0.856,0-1.585,0.317-2.155,3.042c-0.57,2.726-1.965,4.944-3.486,4.944s-2.915-2.219-3.486-4.944 c-0.57-2.725-1.299-3.042-2.154-3.042c-1.332,0-3.392,4.184-3.392,7.892c0,4.341,1.069,7.582,3.074,7.89 c1.441,0.223,3.115-0.619,4.024-2.027c0.621-0.959,0.983-1.711,1.934-1.711c0.951,0,1.313,0.752,1.934,1.711 c0.91,1.408,2.583,2.25,4.025,2.027c2.004-0.309,3.074-3.549,3.074-7.89C25.353,11.522,23.292,7.339,21.961,7.339z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M16.14,9.213c0-3.237-0.105-4.537-0.742-4.855c-0.637-0.318-0.922,0.266-1.827,0 c-0.905-0.265-1.941-0.072-1.145,0.902c0.746,0.911,1.718,1.138,1.77,2.626C14.249,9.375,16.14,9.903,16.14,9.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C355E"
    },
    d: "M16.499,9.213c0-3.237,0.105-4.537,0.743-4.855c0.637-0.318,0.922,0.266,1.827,0 c0.904-0.265,1.94-0.072,1.145,0.902c-0.746,0.911-1.718,1.138-1.771,2.626C18.39,9.375,16.499,9.903,16.499,9.213z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.2051,
    y1: 20.0537,
    x2: 12.2051,
    y2: 8.5898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_1_)"
    },
    d: "M12.378,11.075c-0.164-0.782-0.342-1.35-0.533-1.761l0,0 c-0.667-0.861-1.524-1.324-2.259,0.792c-0.734,2.115-1.366,9.076,1.129,9.872c1.75,0.559,4.365-2.057,4.658-2.908 c0.146-0.424,0.133-0.928-0.012-1.432C14.05,15.414,12.875,13.453,12.378,11.075z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.2676,
    y1: 20.0547,
    x2: 16.2676,
    y2: 8.5894,
    gradientTransform: "matrix(-1 0 0 1 36.5352 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_2_)"
    },
    d: "M20.095,11.075c0.164-0.782,0.342-1.35,0.532-1.761l0,0 c0.668-0.861,1.524-1.324,2.26,0.792c0.734,2.115,1.365,9.076-1.13,9.872c-1.75,0.559-4.365-2.057-4.658-2.908 c-0.146-0.424-0.133-0.928,0.012-1.432C18.423,15.414,19.598,13.453,20.095,11.075z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndocrinology);
export default __webpack_public_path__ + "static/media/endocrinology.fcf024427792fcc21c284723b5d5a719.svg";
export { ForwardRef as ReactComponent };